import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface TeacherIntroState {
  // true while the teacher welcome onboarding (intro/wizard/summary) is on screen.
  onboardingActive: boolean;
}

const initialState: TeacherIntroState = { onboardingActive: false };

export const teacherIntroSlice = createSlice({
  name: 'teacherIntro',
  initialState,
  reducers: {
    setTeacherOnboardingActive: (state: TeacherIntroState, action: PayloadAction<boolean>) => {
      state.onboardingActive = action.payload;
    },
  },
});

export const selectTeacherOnboardingActive = (state: RootState) => state.teacherIntro.onboardingActive;

export const { setTeacherOnboardingActive } = teacherIntroSlice.actions;

export default teacherIntroSlice.reducer;
